import ApplicationController from "../turbo/application_controller";

/**
 * A controller used to filter list items based on the result of a search
 * input.
 *
 * This controller requires two things:
 *
 *  1. an input field with an action of "keyup->search-filter#search"
 *  2. a list of items which will be shown/hidden based on the search term
 *
 * The comparison is a simple lowercase inclusion check. As this is used more,
 * we could allow the constructor to define different comparison operations.
 *
 * An example of this controller can be found on the email sync company settings
 * page, for filtering company users.
 */
export default class extends ApplicationController {
    static targets = ["item", "searchItemWrapper", "input", "clear"];

    search({ target }) {
        const searchTerm = target.value.toLowerCase();

        this.itemTargets.forEach(item => {
            const comparableSearchTerm = item.dataset.searchterm.toLowerCase();
            const matching_search = comparableSearchTerm.includes(searchTerm);

            item.classList.toggle("hidden", !matching_search);
        });

        if (this.hasSearchItemWrapperTarget) {
            this.searchItemWrapperTargets.forEach(wrapper => {
                const containsVisibleItem = Array.from(wrapper.querySelectorAll("[data-searchterm]"))
                    .some(item => !item.classList.contains("hidden"));

                wrapper.classList.toggle("hidden", !containsVisibleItem);
                wrapper.dispatchEvent(new CustomEvent("searchResult", { detail: { item: wrapper, matching: containsVisibleItem, searchTerm: searchTerm } }));
            });
        }
    }

    clear() {
        this.clearTarget.classList.add("hidden");
        this.inputTarget.value = "";
        this.search({ target: { value: "" } });
    }

    inputTargetConnected() {
        this.inputTarget.addEventListener("clear", this.clear.bind(this));

        this.inputTarget.addEventListener("input", () => {
            this.clearTarget.classList.toggle("hidden", this.inputTarget.value === "");
        });
    }
}
